const searchDurationMap = (duration: number): string => {
  switch (true) {
    case duration < 15:
      return '10:15'
    case duration < 25:
      return '15:25'
    case duration < 35:
      return '25:35'
    case duration < 45:
      return '35:45'
    default:
      return '45:'
  }
}

export default searchDurationMap
